var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-logo-wrapper"},[_c('span',[_vm._v("U")]),_c('span',[_vm._v("Bazar")])])}]

export { render, staticRenderFns }